import { localStorageHandler } from '../shared/localStorageHandler';

/**
 * Remembers an issue the visitor touched while signed out, under the
 * `anonymousIssueIds` storage key. Registration sends the list with
 * `registerWithAuthCode`, which re-attributes those issues and their
 * anonymous messages to the new account. Idempotent per id. A malformed
 * stored value is treated as empty rather than thrown, so a stale or
 * hand-edited entry cannot block posting.
 */
export const trackAnonymousIssueId = async (
  storageKey: string,
  issueId: string
): Promise<string[]> => {
  const ids = parseStoredIds(await localStorageHandler.getItem(storageKey));
  if (!ids.includes(issueId)) {
    ids.push(issueId);
  }
  await localStorageHandler.setItem(storageKey, JSON.stringify(ids));
  return ids;
};

const parseStoredIds = (stored: string | null): string[] => {
  if (!stored) return [];
  try {
    const parsed: unknown = JSON.parse(stored);
    return Array.isArray(parsed)
      ? parsed.filter((x): x is string => typeof x === 'string' && !!x)
      : [];
  } catch {
    return [];
  }
};
